import QuizImage from './QuizImage';

export default QuizImage;
